import { useRef } from "react";

const randomId = () => {
  return `pafyll-${Math.random().toString(36).substr(2, 9)}`;
};

const useId = (id?: string, generateId: () => string = randomId) => {
  const generatedId = useRef(generateId());
  return id || generatedId.current;
};

export default useId;
